import { Component } from 'react'
import { HiHashtag } from 'react-icons/hi'
import { appRef } from '../../app'
import { RouteComponentProps } from 'react-router-dom'
import { getString } from '../../locale'
import { ISoftwareVersion } from '../../api/0x0001/software-versions'
import { SoftwareVersionForm } from './software-version-form'

type Params = {
    softwareVersionId: string
}

type State = {}

type Props = RouteComponentProps<Params>

export class SoftwareVersion extends Component<Props, State> {
    state: State = {}

    softwareVersionId: ISoftwareVersion['id']

    constructor(props: Props) {
        super(props)
        this.softwareVersionId = Number(this.props.match.params.softwareVersionId)
    }

    componentDidMount = () => {
        appRef.setHeader(<HiHashtag className="me-2" size={28} />, () => `${getString('pagelabels.software-version')} ${this.softwareVersionId}`)
    }

    render() {
        return (
            <div className="container">
                <SoftwareVersionForm softwareVersionId={this.softwareVersionId} />
            </div>
        )
    }
}
